import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import { StageContext } from '../../Context';

export interface OneEveryThreeStageParameters extends StageParameters {}

class OneEveryThreeStage extends FilterStage<OneEveryThreeStageParameters> {
    constructor() {
        super({});
    }

    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        const floor = sensorData.getSensorPoint().getFloor();

        return floor % 3 == 0;
    }
}

export default OneEveryThreeStage;
